import { graphql, useStaticQuery } from 'gatsby'
import { RenderClient } from 'src/components/RenderClient'
import { PromotionalPhrase } from './PromotionalPhrase'

type TopHeaderItem = {
  label: string
  url: string
}

export const TopHeader = () => {
  const topHeaderData = useStaticQuery(graphql`
    query TopHeaderQuery {
      cmsTopHeader {
        topHeader {
          topHeaderItems {
            topHeaderItems {
              label
              url
            }
            promotionalPhrase
          }
        }
      }
    }
  `)

  return (
    <div className="bg-black px-6 py-1 lg:px-10 global-topheader">
      <div className="flex flex-row flex-nowrap md:gap-4 lg:gap-6 items-center justify-center md:justify-between">
        <div className="hidden md:block">
          <div className="flex flex-row flex-nowrap items-center gap-6 px-1">
            {topHeaderData.cmsTopHeader.topHeader.topHeaderItems.topHeaderItems.map(
              (item: TopHeaderItem, index: number) => (
                <a
                  key={`top-header-item-${index}`}
                  href={`${item.url}`}
                  className="block text-[10px] leading-[130%] tracking-[0.15px] font-normal text-white no-underline"
                >
                  {item.label}
                </a>
              )
            )}
          </div>
        </div>
        <div className="">
          <RenderClient>
            <PromotionalPhrase
              promotionalPhrase={
                topHeaderData.cmsTopHeader.topHeader.topHeaderItems
                  .promotionalPhrase
              }
            />
          </RenderClient>
        </div>
      </div>
    </div>
  )
}
